import script from "./TradingHall.vue?vue&type=script&setup=true&lang=js"
export * from "./TradingHall.vue?vue&type=script&setup=true&lang=js"

import "./TradingHall.vue?vue&type=style&index=0&id=83a68782&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83a68782"]])

export default __exports__